<template>
  <Teleport to="#bk-blokkli-item-actions">
    <button
      ref="el"
      :disabled="isDisabled"
      :class="{ 'bk-is-active': active, 'bk-is-last': weight === 'last' }"
      :style="weight !== 'last' ? { order: weight || 0 } : void 0"
      @click.prevent.stop="onClick"
    >
      <slot name="icon">
        <Icon v-if="icon" :name="icon" />
      </slot>
      <div class="bk-tooltip">
        <span>{{ title }}</span>
        <ShortcutIndicator
          v-if="keyCode"
          :meta="meta"
          :label="title"
          :key-code="keyCode"
          group="blocks"
          @pressed="onClick"
        />
      </div>
    </button>
  </Teleport>
  <Teleport to="#bk-blokkli-item-actions-after">
    <slot :items="selection.blocks.value" :uuids="uuids" />
  </Teleport>
</template>

<script setup>
import { computed, ref, useBlokkli } from "#imports";
import { Icon, ShortcutIndicator } from "#blokkli/components";
import defineCommands from "#blokkli/helpers/composables/defineCommands";
import defineTourItem from "#blokkli/helpers/composables/defineTourItem";
const { selection } = useBlokkli();
const el = ref(null);
const uuids = computed(() => selection.uuids.value);
const props = defineProps({
  id: { type: String, required: true },
  title: { type: String, required: true },
  disabled: { type: Boolean, required: false },
  active: { type: Boolean, required: false },
  keyCode: { type: String, required: false },
  meta: { type: Boolean, required: false },
  multiple: { type: Boolean, required: false },
  weight: { type: [Number, String], required: false },
  icon: { type: null, required: false },
  tourText: { type: String, required: false }
});
const isDisabled = computed(
  () => props.disabled || !props.multiple && selection.blocks.value.length > 1
);
const emit = defineEmits(["click"]);
const onClick = () => {
  if (isDisabled.value || !uuids.value.length) {
    return;
  }
  emit("click", selection.blocks.value);
};
defineCommands(() => ({
  id: "plugin:item_action:" + props.id,
  group: "selection",
  label: props.title,
  icon: props.icon,
  disabled: props.disabled || !selection.blocks.value.length,
  callback: onClick
}));
defineTourItem(() => {
  if (!props.tourText) {
    return;
  }
  return {
    id: "plugin:item_action:" + props.id,
    title: props.title,
    text: props.tourText,
    element: () => el.value
  };
});
</script>

<script>
export default {
  name: "PluginItemAction"
};
</script>
